"use client";

import { ElementType } from "react";
import classNames from "classnames";
import { useParams } from "next/navigation";
import { HeadlineProps } from "@/types/component.types";

type CombinedHeadlineProps = {
  blok?: HeadlineProps;
  className?: string;
  text?: string;
  level?: "h1" | "h2" | "h3" | string;
  tag?: string;
};

export default function Headline({
  blok,
  className = "",
  text: directText,
  level: directLevel,
  tag: directTag,
}: CombinedHeadlineProps) {

  const params = useParams();
  const lang = (params?.lang as string) || "de";

  const text = blok?.text || directText;

  const rawLevel = blok?.level ? (Array.isArray(blok.level) ? blok.level[0] : blok.level) : directLevel;
  const rawTag = blok?.tag ? (Array.isArray(blok.tag) ? blok.tag[0] : blok.tag) : directTag;

  const level = (rawLevel as "h1" | "h2" | "h3") || "h2";

  const Tag = (rawTag || level || "h2") as ElementType; 

  const baseStyles = "text-black dark:text-beige hyphens-auto";  
  const styles = {
    h1: "text-[42px]/[42px] md:text-[48px]/[54px] xl:text-[54px]/[60px] font-funnel-bold",
    h2: "text-[34px]/[40px] md:text-[38px]/[46px] xl:text-[42px]/[52px] font-funnel-bold",
    h3: "text-[26px]/[32px] md:text-[28px]/[38px] xl:text-[30px]/[44px] font-funnel-bold",
    h4: "text-[20px]/[26px] md:text-[22px]/[32px] xl:text-[24px]/[36px] font-funnel-regular",
  };

  return (
    <Tag
      lang={lang} 
      className={classNames(
        baseStyles, 
        styles[level as keyof typeof styles] || styles.h2, 
        blok && "w-full", 
        className
      )}
    >
      {text}
    </Tag>
  );
}